export const Footer = () => {
    return (
        <div className="footer">
            <img src="/logo-white.png" alt="" />
            <div>
                <p>Contacts</p>
                <p>📞 Phone: +374-77-03-1191</p>
                <p>📧 Email: mesropian.ling.center@gmail.com</p>
                <a href="https://www.instagram.com/mesropian_linguistic_center?igsh=MWh4cWo0anZwYzZybg%3D%3D"><img src="/insta.png" alt="" /></a>
                <a href="https://www.facebook.com/people/Mesropian-Linguistic-Center/61570859967241/?mibextid=wwXIfr&rdid=928BqfAMdz7Digud&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1ARXepxgPE%2F%3Fmibextid%3DwwXIfr"><img src="/face.png" alt="" /></a>
            </div>
        </div>
    );
};
